import { FC, useCallback, MouseEvent, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { OrganizationInfo, SpaceInfo } from 'src/api/types';
import { getIsDesktop } from 'src/store/agent/selectors';
import { getSpacesState } from 'src/store/spaces/selectors';
import { spacesActions } from 'src/store/spaces/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { useSpaces } from '../SpacesProvider';

import { DesktopSpaceCard } from './DesktopSpaceCard/DesktopSpaceCard';
import { MobileSpaceCard } from './MobileSpaceCard/MobileSpaceCard';

export interface SpaceCardProps {
  space: SpaceInfo;
}

export const SpaceCard: FC<SpaceCardProps> = ({ space }) => {
  const isDesktop = useSelector(getIsDesktop);
  const dispatch = useAppDispatch();
  const { removeSpace } = useSpaces();
  const { removings } = useSelector(getSpacesState);

  const open = useCallback(() => {
    dispatch(spacesActions.openSpace(space));
  }, [dispatch, space]);

  const deleteSpace = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      removeSpace(space.spaceId);
    },
    [removeSpace, space.spaceId],
  );

  const org = useMemo(() => {
    const organization = space.organizations[0] as OrganizationInfo | undefined;
    const parentOrganization = organization?.parent;
    let result = organization?.name ?? 'Подразделение';
    if (parentOrganization?.name) result += ` / ${parentOrganization.name}`;
    return result;
  }, [space.organizations]);

  return isDesktop ? (
    <DesktopSpaceCard
      title={space.title}
      org={org}
      desksCount={space.places.length}
      onOpen={open}
      onDelete={deleteSpace}
      disabled={removings.has(space.spaceId)}
    />
  ) : (
    <MobileSpaceCard
      title={space.title}
      org={org}
      desksCount={space.places.length}
      onOpen={open}
      onDelete={deleteSpace}
      disabled={removings.has(space.spaceId)}
    />
  );
};
